import moment from 'moment';
import _ from 'lodash';

export default {
    methods: {
        logout() {
            this.$inertia.post(route('logout'));
            this.$cookie.delete('ignoreKyc');
        },

        sleep(delay) {
            return new Promise((resolve) => setTimeout(resolve, delay));
        },

        goto(routeName, param = null) {
            this.$inertia.get(param ? route(routeName, param) : route(routeName));
        },

        newTab(routeName, param = null) {
            window.open(param ? route(routeName, param) : route(routeName));
        },

        moment(data) {
            return data ? moment(data) : moment();
        },

        errors(attribute) {
            if (
                Object.keys(this.$page.props.errors).length
                && Object.prototype.hasOwnProperty.call(this.$page.props.errors, attribute)
            ) {
                return this.$page.props.errors[attribute];
            }
            return false;
        },

        toCapitalize(string) {
            return _.capitalize(string);
        },

        toCamelCase(string) {
            return _.camelCase(string);
        },

        toSnakeCase(string) {
            return _.snakeCase(string);
        },

        userConfigValue(config, user) {
            if (user) {
                return config.values.find((value) => value.user_id === user.id)?.value ?? config.values.find((value) => value.user_id === null)?.value;
            }
            return config.values.find((value) => value.user_id === null)?.value;
        },

        config(key, user = null) {
            return this.userConfigValue(this.$page.props.config.find((obj) => obj.key === key), user);
        },

        async downloadImage(imageSrc) {
            const image = await fetch(imageSrc);
            const imageBlog = await image.blob();
            const imageURL = URL.createObjectURL(imageBlog);

            const link = document.createElement('a');
            link.href = imageURL;
            link.download = 'image file name here';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        openImageInNewTab(imageSrc) {
            window.open(imageSrc);
        },

        authUserCanPurchaseProduct(product) {
            if ((this.isRetailer || this.isSalesperson) && product.available_stock >= 1) {
                if (this.hasUnpaidCodBillsWith(product.owner)) {
                    return false;
                }

                const creditWithProductOwner = this.$page.props.user.credit.find((eachCredit) => eachCredit.wholesaler_id === product.user_id);
                if (creditWithProductOwner) {
                    if (creditWithProductOwner.credit_balance > 0) {
                        return true;
                    }
                    return false;
                }
                return true;
            }
            return false;
        },

        hasUnpaidCodBillsWith(wholesaler) {
            return !!this.$page.props.user.bills.filter(
                (bill) => bill.wholesaler_id === wholesaler.id && bill.payment_method === 'COD'
            ).length;
        },

        convertToKebabCase(string) {
            return _.kebabCase(string);
        },

    },
};
